import {
  Pagination,
  TablePagination as MuiTablePagination,
} from "@mui/material";

import { submitEvent } from "../utils/tracking";

function TablePagination({
  count,
  page,
  setPage,
  rowsPerPageOptions = [10, 25, 50],
  rowsPerPage,
  setRowsPerPage,
  resetPageOnRowsPerPageChange = true,
}) {
  return (
    <MuiTablePagination
      sx={{
        ".MuiTablePagination-toolbar": { minHeight: "4em" },
        ".MuiTablePagination-displayedRows": { marginRight: "43px" },
      }}
      rowsPerPageOptions={rowsPerPageOptions}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(_, newPage) => {
        setPage(newPage);
      }}
      onRowsPerPageChange={({ target: { value } }) => {
        submitEvent("Pagination Changed");
        setRowsPerPage(+value);
        if (resetPageOnRowsPerPageChange) {
          setPage(0);
        }
      }}
      ActionsComponent={() => (
        <Pagination
          sx={{ ".MuiPagination-ul": { flexWrap: "nowrap" } }}
          color="brandSupporting"
          count={Math.ceil(count / rowsPerPage)}
          page={page + 1}
          onChange={(_, value) => setPage(value - 1)}
        />
      )}
    />
  );
}

export default TablePagination;
